module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0022.jpg?v=fe122505";